import type React from 'react';
import type { IconProps } from 'types/icon';
import { SvgIcon } from './svg-icon';

const CheckCircleOutlined: React.FC<IconProps> = (props) => (
  <SvgIcon {...props}>
    {(c) => (
      <>
        <circle cx="12" cy="12" r="10" stroke={c} strokeWidth="1.5" />
        <path
          d="M8.5 12.5L10.5 14.5L15.5 9.5"
          stroke={c}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </>
    )}
  </SvgIcon>
);

export default CheckCircleOutlined;
